import { render } from "./CreateServiceReport1.vue?vue&type=template&id=d58fffca"
import script from "./CreateServiceReport1.vue?vue&type=script&lang=js"
export * from "./CreateServiceReport1.vue?vue&type=script&lang=js"

import "./CreateServiceReport1.vue?vue&type=style&index=0&id=d58fffca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__